import React from "react";
import { Form, Navigate } from "react-router-dom";
import { isLogin } from "../js/helper";

const PrivateRoute =({component:Component, isChangePassword, ...rest})=>{

    if(isLogin()){
        if (isChangePassword) {
            let allowPasswordChange = sessionStorage.getItem("allowPasswordChange");
            if (allowPasswordChange !== "true") {
                return <Navigate to="/merchantpage"/>;
            }
        }
        if(Component.name === "Dashboard") {
            let userData = sessionStorage.getItem("userDetails");
            let userDataJson = JSON.parse(userData);
            if(!userDataJson.showDashboard) {
                return <Navigate to="/Add-items"/>;
            }
        }
        return <Component {...rest}/>;
    }
    return <Navigate to="/"/>;
};
export default PrivateRoute;
